import Auth from "../panels/auth/Layout.vue";
import routes from "../routes/auth";
import globalSetup from "./shared/globalSetup";

globalSetup(Auth, routes, "/auth/");
